import React from 'react';
import { Filter, X } from 'lucide-react';
import { EVIDENCE_TIERS } from '../../../constants/evidenceTiers';

const TaskListFilters = ({ filters, onFilterChange, onClearFilters }) => {
  const hasActiveFilters = filters.status || filters.priority || filters.category || filters.integrationSource || filters.evidenceTier;

  return (
    <div className="mb-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
      <div className="flex items-center gap-2 mb-3">
        <Filter className="w-4 h-4 text-gray-600" />
        <span className="text-sm font-medium text-gray-700">Filters</span>
        {hasActiveFilters && (
          <button
            onClick={onClearFilters}
            className="ml-auto text-xs text-teal-600 hover:text-teal-700 font-medium flex items-center gap-1"
          >
            <X className="w-3 h-3" />
            Clear All
          </button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3">
        {/* Status Filter */}
        <div>
          <label className="block text-xs text-gray-600 mb-1">Status</label>
          <select
            value={filters.status || ''}
            onChange={(e) => onFilterChange('status', e.target.value || null)}
            className="w-full px-3 py-2 bg-white border border-gray-300 text-gray-900 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          >
            <option value="">All Statuses</option>
            <option value="pending">Pending</option>
            <option value="auto_verified">Auto Verified</option>
            <option value="manually_verified">Manually Verified</option>
            <option value="failed">Failed</option>
          </select>
        </div>

        {/* Priority Filter */}
        <div>
          <label className="block text-xs text-gray-600 mb-1">Priority</label>
          <select
            value={filters.priority || ''}
            onChange={(e) => onFilterChange('priority', e.target.value || null)}
            className="w-full px-3 py-2 bg-white border border-gray-300 text-gray-900 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          >
            <option value="">All Priorities</option>
            <option value="critical">Critical</option>
            <option value="high">High</option>
            <option value="medium">Medium</option>
            <option value="low">Low</option>
          </select>
        </div>

        {/* Category Filter */}
        <div>
          <label className="block text-xs text-gray-600 mb-1">TSC Category</label>
          <select
            value={filters.category || ''}
            onChange={(e) => onFilterChange('category', e.target.value || null)}
            className="w-full px-3 py-2 bg-white border border-gray-300 text-gray-900 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          >
            <option value="">All Categories</option>
            <option value="CC">Common Criteria</option>
            <option value="Security">Security</option>
            <option value="Availability">Availability</option>
            <option value="Processing Integrity">Processing Integrity</option>
            <option value="Confidentiality">Confidentiality</option>
            <option value="Privacy">Privacy</option>
          </select>
        </div>

        {/* Integration Source Filter */}
        <div>
          <label className="block text-xs text-gray-600 mb-1">Integration Source</label>
          <select
            value={filters.integrationSource || ''}
            onChange={(e) => onFilterChange('integrationSource', e.target.value || null)}
            className="w-full px-3 py-2 bg-white border border-gray-300 text-gray-900 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          >
            <option value="">All Sources</option>
            <option value="aws">AWS</option>
            <option value="google_workspace">Google Workspace</option>
            <option value="github">GitHub</option>
            <option value="manual">Manual Only</option>
          </select>
        </div>

        {/* Evidence Quality Filter */}
        <div>
          <label className="block text-xs text-gray-600 mb-1">Evidence Quality</label>
          <select
            value={filters.evidenceTier || ''}
            onChange={(e) => onFilterChange('evidenceTier', e.target.value || null)}
            className="w-full px-3 py-2 bg-white border border-gray-300 text-gray-900 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          >
            <option value="">All</option>
            {EVIDENCE_TIERS.map((tier) => (
              <option key={tier.key} value={tier.key}>{tier.label}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default TaskListFilters;
